// REFACTOR: Do not depend on specific database ID references (not stable).
const baseEmployeeAttrIds = {
  FIRST_NAME: 1,
  LAST_NAME: 2,
  COMPANY_EMPLOYEE_ID: 3,
  EMAIL: 4,
  MANAGER_EMPLOYEE_ID: 5,
};

const OWN_ATTRIBUTE_VALUE = 'OWN_ATTRIBUTE_VALUE';

const queryParamLabel = 'attributes';

const noHeaderPrefix = '_undefined_';

export { OWN_ATTRIBUTE_VALUE, baseEmployeeAttrIds, queryParamLabel, noHeaderPrefix };
